import { deleteRequest } from '@/core';
import { trips } from '@/requests';

export default async function deleteTripsRequest(tripIds) {
	let url = trips.getDeletePath();
	let response = await deleteRequest(url, {}, { tripIds });
	return response;
}
